import api from '../../../services/CoreAPI';
import * as types from './action-types';

const pullCreditUnfreeze = () => ({
    asyncAction: () => api.pullCreditUnfreeze(),
    type: types.PULL_CREDIT,
});

const reset = () => ({
    type: types.PULL_CREDIT_RESET,
});

export default {
    pullCreditUnfreeze,
    reset
};
